import React from 'react';
import Moment from 'react-moment';

import Thumbnail from '../../generic/Thumbnail';
import abbreviateDuration from '../../utils/abbreviate-duration';
import abbreviateFileSize from '../../utils/abbreviate-file-size';

export const thumbnail = {
  Header: '',
  accessor: 'fileUrl',
  Cell: row => {
    const id = `creatives-list-${row.original.id}`;
    return (
      <Thumbnail
        id={id}
        key={id}
        alt={row.original.name}
        src={row.original.thumbnailUrl}
        previewSrc={row.value}
        type={row.original.fileType}
      />
    );
  },
  width: 91,
  filterable: false,
  sortable: false,
};

export const size = {
  Header: 'Size',
  accessor: 'size',
  Cell: row => {
    const {
      original: { imageWidth, imageHeight, fileSize, aspectRatio, duration },
    } = row;
    const widthHeight =
      imageWidth && imageHeight ? `${imageWidth} X ${imageHeight}` : '-';
    return (
      <>
        {widthHeight}
        {duration !== null && (
          <>
            <div>{aspectRatio}</div>
            <div>{abbreviateDuration(duration)}</div>
          </>
        )}
        <div className="text-muted">
          {abbreviateFileSize(parseInt(fileSize, 10))}
        </div>
      </>
    );
  },
  width: 72,
  filterable: false,
  sortable: false,
};

export const owner = { Header: 'Owner', accessor: 'createdBy', width: 100 };

export const uploadedBy = {
  Header: 'Uploaded by',
  accessor: 'createdBy',
  Cell: row => {
    return (
      <>
        {row.value}
        <br />
        <span className="small text-muted">
          <Moment fromNow>{row.original.created}</Moment>
        </span>
      </>
    );
  },
  width: 80,
  filterable: false,
};
